import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import CarrierEquipmentSerializer from "../serializers/CarrierEquipmentSerializer";
import CarrierSerializer from "../serializers/CarrierSerializer";
import ContactSerializer from "../serializers/ContactSerializer";
import HistoricalLoadSerializer from "../serializers/HistoricalLoadSerializer";
import CarrierSearchSerializer from "../serializers/CarrierSearchSerializer";
import CarrierExtraPaySerializer from "../serializers/CarrierExtraPaySerializer";
import CarrierCommissionSerializer from "../serializers/CarrierCommissionSerializer";
import CarrierPreferredLanesSerializer from "../serializers/CarrierPreferredLanesSerializer";
import OfferSerializer from "../serializers/OfferSerializer";
import OfferSummarySerializer from "../serializers/OfferSummarySerializer";
import DeclineReasonSerializer from "../serializers/DeclineReasonSerializer";
import CarrierSavedSearchSerializer from "../serializers/CarrierSavedSearchSerializer";
import CarrierPostedTruckSerializer from "../serializers/CarrierPostedTruckSerializer";
import LaneFreightMatchingSerializer from "../serializers/LaneFreightMatchingSerializer";
import FreightMatchingSerializer from "../serializers/FreightMatchingSerializer";
import NetworkMatchingRemovedSerializer from "../serializers/NetworkMatchingRemovedSerializer";
import ComcheckSerializer from "../serializers/ComcheckSerializer";
import DeductCodeSerializer from "../serializers/DeductCodeSeriaizer";
import ReasonsSerializer from "../serializers/ReasonsSerializer";
import CallInSerializer from "../serializers/CallInSerializer";
import MovementSerializer from "../serializers/MovementSerializer";
import CallInStatusSerializer from "../serializers/CallInStatusSerializer";
import CallInLogSerializer from "../serializers/CallInLogSerializer";
import CallInStopsTimes from "../serializers/CallInStopTimesSerializer";
import StopSerializer from "../serializers/StopSerializer";

export default class CarrierRepository {
  CARRIERS_BASE = "/api/carriers";
  CARRIER_BASE = "/api/carrier";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async findCarrier(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/search/contains?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve(
        req.carriers.map(carrier => (
          CarrierSerializer.deSerialize(carrier)
        ))
      );
    }
    else {
      return Promise.resolve([]);
    }
  }

  async findCarriers(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/search?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve(req.carriers.map(carrier => (CarrierSerializer.deSerialize(
        carrier
      ))
      ));
    }
    else {
      return Promise.resolve([]);
    }
  }

  async findCarriersAdvanced(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/carriersearchadvanced?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve(req.carriers);
    }
    else {
      return Promise.resolve([]);
    }
  }

  async homeLocationSearch(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/homelocationsearch?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.homeLocationTableResponse) {
      return Promise.resolve(req.homeLocationTableResponse);
    }
    else {
      return Promise.resolve([]);
    }
  }

  async getCarrierSavedSearchByUser(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/carriersearch?userObjectId=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    return Promise.resolve(req.carrierSearch);
  }

  async createCarrierSavedSearch(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/carriersearch/create`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ carrierSearch: CarrierSavedSearchSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierSavedSearchSerializer.deSerialize(req.carrierSearch));
  }

  async updateCarrierSavedSearch(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/carriersearch/update`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ carrierSearch: CarrierSavedSearchSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierSavedSearchSerializer.deSerialize(req.carrierSearch));
  }

  async getCarrier(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(CarrierSerializer.deSerialize(req.payee));
  }

  async updateCarrier(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ payee: CarrierSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierSerializer.deSerialize(req.payee));
  }

  async updateCarrierDynamic(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/dynamic`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ Payee: payload })
    });

    return Promise.resolve(CarrierSerializer.deSerialize(req.payee));
  }

  async getCarrierEquipmentTypes(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/equipment/type`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    if (req.equipmentTypes) {
      return Promise.resolve(req.equipmentTypes);
    } else {
      return Promise.resolve([]);
    }
  }

  async getCarrierEquipment(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/equipment?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.equipmentList) {
      return Promise.resolve(req.equipmentList.map(equipment => (
        CarrierEquipmentSerializer.deSerialize(equipment)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async createCarrierEquipment(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/equipment`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ drsPayeeEquipment: CarrierEquipmentSerializer.serialize(payload) })
    });

    if (req.drsPayeeEquipment) {
      return Promise.resolve(CarrierEquipmentSerializer.deSerialize(req.drsPayeeEquipment));
    } else {
      return Promise.resolve({});
    }
  }

  async updateCarrierEquipment(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/equipment`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ drsPayeeEquipment: CarrierEquipmentSerializer.serialize(payload) })
    });

    if (req.drsPayeeEquipment) {
      return Promise.resolve(CarrierEquipmentSerializer.deSerialize(req.drsPayeeEquipment));
    } else {
      return Promise.resolve({});
    }
  }

  async deleteCarrierEquipment(instance, equipmentId) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/equipment?id=${equipmentId}`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "DELETE",
      headers: this.headers,
    });

    return Promise.resolve({});
  }

  async updateCarrierInsurance(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/insurance`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Insurance";
    this.headers.Action = `Carrier ${payload.id} insurance updated`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ payee: CarrierSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierSerializer.deSerialize(req.payee));
  }

  async getCarrierContacts(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/contacts?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.contacts) {
      return Promise.resolve(req.contacts.map(contact => (
        ContactSerializer.deSerialize(contact)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async createCarrierContact(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/contact`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Contacts";
    this.headers.Action = `Created new contact for carrier ${payload.carrierId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ contact: ContactSerializer.serialize(payload) })
    });

    return Promise.resolve(ContactSerializer.deSerialize(req.contact));
  }

  async updateCarrierContact(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/contact`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Contacts";
    this.headers.Action = `Updated contact for carrier ${payload.carrierId}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ contact: ContactSerializer.serialize(payload) })
    });

    return Promise.resolve(ContactSerializer.deSerialize(req.contact));
  }

  async getCarrierLoads(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/loads?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    if (req.loads) {
      return Promise.resolve({
        loads: req.loads.map(load => (
          HistoricalLoadSerializer.deSerialize(load)
        )),
        maxRows: req.maxRows
      });
    } else {
      return Promise.resolve({});
    }
  }

  async getCarriersByOrigin(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/pickups?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve({
        carriers: req.carriers.map(carrier => (
          CarrierSearchSerializer.deSerialize(carrier)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getCarriersByLane(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/destination/lane?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve({
        carriers: req.carriers.map(carrier => (
          CarrierSearchSerializer.deSerialize(carrier)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getCarriersByState(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/destination/lane/bystate?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carriers) {
      return Promise.resolve({
        carriers: req.carriers.map(carrier => (
          CarrierSearchSerializer.deSerialize(carrier)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getCarrierExtraPay(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/carrierExtraPay?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.carrierExtraPay) {
      return Promise.resolve(
        req.carrierExtraPay.map(extraPay => (
          CarrierExtraPaySerializer.deSerialize(extraPay)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async createCarrierExtraPay(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/extrapay`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Accessorial";
    this.headers.Action = `Added ${payload.shortDescription} accessorial for order #${payload.orderId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ DriverExtraPay: CarrierExtraPaySerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierExtraPaySerializer.deSerialize(req.driverExtraPay));
  }

  async updateCarrierExtraPay(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/extrapay`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Accessorial";
    this.headers.Action = `Updated ${payload.shortDescription} accessorial for order #${payload.orderId}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ DriverExtraPay: CarrierExtraPaySerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierExtraPaySerializer.deSerialize(req.driverExtraPay));
  }

  async deleteCarrierExtraPay(instance, params, accessorialToDelete) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/extrapay?${params}`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Accessorial";
    this.headers.Action = `Deleted ${accessorialToDelete.shortDescription} accessorial for order #${accessorialToDelete.orderId}`;

    await request(path, {
      method: "DELETE",
      headers: this.headers
    });

    return Promise.resolve();
  }

  async getCarrierExtraPayTypes(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/deductcodeaccessorial`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.deductCode) {
      return Promise.resolve(
        req.deductCode.map(code => (
          DeductCodeSerializer.deSerialize(code)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async getCarrierCommissionValues(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/targetPay/commission/config`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(CarrierCommissionSerializer.deSerialize(req));
  }

  async getLoadTotals(instance, loadId) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/order/offers/summary?orderId=${loadId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(OfferSummarySerializer.deSerialize(req.offerSummary));
  }

  async getLoadOffers(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/order/offers?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.offers) {
      return Promise.resolve({
        offers: req.offers.map(offer => (
          OfferSerializer.deSerialize(offer)
        )),
        carrierScorecard: req.carrierScorecard
      });
    } else {
      return Promise.resolve({ offers: [], carrierScorecard: [] });
    }
  }

  async createCarrierOffer(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offer`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Offers";
    this.headers.Action = `Submitted offer for carrier ${payload.carrierId} on load ${payload.orderId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ carrierOffer: OfferSerializer.serialize(payload) })
    });

    return Promise.resolve(OfferSerializer.deSerialize(req.carrierOffer));
  }

  async updateCarrierOffer(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offer`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ carrierOffer: OfferSerializer.serialize(payload) })
    });

    return Promise.resolve(OfferSerializer.deSerialize(req.carrierOffer));
  }

  async getDeclineReasons(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offer/declinereason`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.declineReasons.map(reason => (DeclineReasonSerializer.deSerialize(
      reason
    ))));
  }

  async getPreferredLanes(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/preferred/lanes?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.preferredLanes) {
      return Promise.resolve(
        req.preferredLanes.map(lane => (
          CarrierPreferredLanesSerializer.deSerialize(lane)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async getPreferredLane(instance, laneId) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/preferred/lane?laneId=${laneId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(CarrierPreferredLanesSerializer.deSerialize(req.preferredLane));
  }

  async createPreferredLane(instance, payload) {
    const token = await getToken(instance);
    const path = "/api/preferred/lane/create";
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Preferred Lanes";
    this.headers.Action = `Added Preferred Lane for Carrier ${payload.carrierId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ preferredLane: CarrierPreferredLanesSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierPreferredLanesSerializer.deSerialize(req.preferredLane));
  }

  async updatePreferredLane(instance, payload) {
    const token = await getToken(instance);
    const path = "/api/preferred/lane/update";
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ preferredLane: CarrierPreferredLanesSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierPreferredLanesSerializer.deSerialize(req.preferredLane));
  }

  async expirePreferredLane(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/preferred/expirepreferredlane`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async expireAllPreferredLane(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/preferred/expireallpreferredlane`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async getPostedTrucks(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/postedtruck/lanes?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.postedTrucks) {
      return Promise.resolve(
        req.postedTrucks.map(lane => (
          CarrierPostedTruckSerializer.deSerialize(lane)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async createPostedTruck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/postedtruck`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Posted Trucks";
    this.headers.Action = `Added Posted Truck for Carrier ${payload.carrierId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ postedTruck: CarrierPostedTruckSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierPostedTruckSerializer.deSerialize(req.postedTruck));
  }

  async updatePostedTruck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/postedtruck`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ postedTruck: CarrierPostedTruckSerializer.serialize(payload) })
    });

    return Promise.resolve(CarrierPostedTruckSerializer.deSerialize(req.postedTruck));
  }

  async expireAllPostedTruck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/expireallpostedtruck`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async expirePostedTruck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/expirepostedtruck`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async getCarrierFreightMatches(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/availableLoads?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve({
        loads: req.loads.map(load => (
          FreightMatchingSerializer.deSerialize(load)
        )),
        maxRows: req.maxRows
      });
    } else {
      return Promise.resolve({});
    }
  }

  async getLaneFreightMatches(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/lane/availableloads?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.availableLoads) {
      return Promise.resolve({
        availableLoads: req.availableLoads.map(load => (
          LaneFreightMatchingSerializer.deSerialize(load)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getLoadFreightMatches(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/loadmatching?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve({
        loads: req.loads.map(load => (
          FreightMatchingSerializer.deSerialize(load)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async getNetworkFreightMatches(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/network/availableLoads?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve({
        loads: req.loads.map(load => (
          FreightMatchingSerializer.deSerialize(load)
        )),
        maxRows: req.maxRows
      }
      );
    } else {
      return Promise.resolve({});
    }
  }

  async createNetworkMatchingRemoved(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/NetMatchingRemoved`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ carrierNetworkMatchingRemoved: NetworkMatchingRemovedSerializer.serialize(payload) })
    });

    return Promise.resolve(NetworkMatchingRemovedSerializer.deSerialize(req.carrierNetworkMatchingRemoved));
  }

  async deleteNetworkMatchingRemoved(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/NetMatchingRemoved?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "DELETE",
      headers: this.headers
    });

    return Promise.resolve(req);
  }

  async getCarrierQualifications(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/checkqualification?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req);
  }

  async bookLoad(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/bookload`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Load Booking Window";
    this.headers.Action = `Booked load ${payload.orderId} on carrier ${payload.carrierId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(MovementSerializer.deSerialize(req.movement));
  }

  async getFuelSurcharge(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/fuelsurcharge`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.fuelSurcharges);
  }

  async createAccessorialComcheck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/comcheck/accessorial`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async createFuelAdvanceComcheck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/comcheck/fueladvance`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async createPaidInFullComcheck(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/comcheck/paidinfull`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async getComcheckFuelCalc(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/comcheck/fuelAdvance?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req) {
      return Promise.resolve(req);
    } else {
      return Promise.resolve({});
    }
  }

  async getComcheckPifCalc(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/comcheck/paidinfull?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req) {
      return Promise.resolve(req);
    } else {
      return Promise.resolve({});
    }
  }

  async getIssuedComchecks(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/comchecks?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.comchecks) {
      return Promise.resolve(
        req.comchecks.map(comcheck => (
          ComcheckSerializer.deSerialize(comcheck)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async getCarrierNetwork(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/leadsrelationships?userId=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req.carrierLeadRelation);
  }

  async addCarrierLead(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/addlead`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Added carrier ${payload.carrierId} as a Lead`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async removeCarrierLead(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/removelead`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Removed carrier ${payload.carrierId} from Lead status`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async removeCarrierRelationship(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/removerelationship`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Removed carrier ${payload.carrierId} from Relationship status`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async getNetworkStatus(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/networkstatus?${params}`;
    this.headers.Authorization = `Bearer ${token}`;
    const req = await request(path, {
      headers: this.headers,
    });

    return Promise.resolve(req.leadNetworkStatus);
  }

  async addManualLead(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/network/manually/updatetolead`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Manually updated carrier ${payload.carrierId} to Lead status with ${payload.userId}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async addManualOpen(instance, payloadOpen) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/network/manually/updatetoopen`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Manually updated carrier ${payloadOpen.carrierId} to Open status`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payloadOpen)
    });

    return Promise.resolve(req);
  }

  async addManualRelat(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/network/manually/updatetorelatn`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Carrier Network";
    this.headers.Action = `Manually updated carrier ${payload.carrierId} to Relationship status with ${payload.userId}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve(req);
  }

  async getReasonCode(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/unassignment/reason`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(ReasonsSerializer.deSerialize(req));
  }

  async getCallInStatuses(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/callinstatus`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(CallInStatusSerializer.callInStatusesDeserializer(req));
  }

  async getCallInsByOrder(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/callinsbyorder?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req?.callins !== null) {
      return Promise.resolve(CallInLogSerializer.callInLogDeserializer(req));
    }
    else {
      return Promise.resolve(req);
    }
  }

  async createCallIn(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/callin`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "CallIn in Load Actions";
    this.headers.Action = `Created new callIn for orderId  ${payload.order_id}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ callin: CallInSerializer.serialize(payload) })
    });

    return Promise.resolve(req);
  }

  async updatesStopsTimes(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/clearstop`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "CallIn in Load Actions";
    this.headers.Action = "Update the stops times in callIn";

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(CallInStopsTimes.stopsTimesSerializer(payload))
    });

    return Promise.resolve(req);
  }

  async updateToDISStatus(instance, params) {
    const token = await getToken(instance);
    const path = `/api/movementstatus?${params}`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "CallIn in Load Actions";
    this.headers.Action = "Update the brokerage status to DIS status";

    const req = await request(path, {
      method: "PUT",
      headers: this.headers
    });

    return Promise.resolve(MovementSerializer.deSerialize(req.movement));
  }

  async getMilesToNextStop(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/stop/distancetonext?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "GET",
      headers: this.headers
    });

    return Promise.resolve(req);
  }

  async getLoadsByRegion(instance, regionId, customerId) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/loads/pendingoffers?regionId=${regionId}&customerId=${customerId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve(req.loads);
    } else {
      return Promise.resolve([]);
    }
  }

  async getLoadsByUser(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/loads/pendingoffersbyuser?userId=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.loads) {
      return Promise.resolve(req.loads);
    } else {
      return Promise.resolve([]);
    }
  }

  async updateOfferAction(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offeraction`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    }
    ,false
    ,false
    ,false);

    return Promise.resolve(req);
  }

  async removeCarrierLoad(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/load/removeassigned`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    }, false, true);

    return Promise.resolve(req);
  }

  async clearLoads(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offers/clear`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve({});
  }

  async unclearLoads(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/offers/unclear`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve({});
  }

  async getCarrierScorecard(instance, params) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/scorecard?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "GET",
      headers: this.headers
    }, true);

    return Promise.resolve(req.carrierScorecard);
  }

  async getCarrierManagers(instance) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/managers`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "GET",
      headers: this.headers
    });

    return Promise.resolve(req.carrierManagers);
  }

  async updateStop(instance, payload, payeeId) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/stop`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ stop: StopSerializer.serialize(payload), payeeId: payeeId })
    });

    return Promise.resolve({ stop: StopSerializer.deSerialize(req) });
  }

  async clearTimeStop(instance, payload, payeeId, lastStopOrderSequence) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/stop/clear-time`;
    this.headers.Authorization = `Bearer ${token}`;
    let serializedStops = [];
    if (payload) {
      serializedStops = payload.map(st => StopSerializer.serialize(st));
    }
    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ stops: serializedStops, payeeId: payeeId, lastStopOrderSequence: lastStopOrderSequence })
    });
    if (req.stops) {
      return Promise.resolve(
        req.stops.map(st => (
          StopSerializer.deSerialize(st)
        ))
      );
    } else {
      return Promise.resolve({});
    }
  }

  async updateMaxPay(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIER_BASE}/overridemaxpay`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(payload)
    }, false, true);

    return Promise.resolve({});
  }

  async updateDispatch(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CARRIERS_BASE}/loads/updatedispatch`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(payload)
    });

    return Promise.resolve({});
  }
}